<!-- 🔧 CREATE: qr-code-dialog.component.html -->
<div class="qr-dialog-container">
    <!-- Dialog Header -->
    <div class="qr-head-part">
        <div class="qr-dialog-header">
            <h2 mat-dialog-title class="dialog-title">
                Generate QR Code
            </h2>
            
        </div>
        <!-- Close Button -->
        <div>
            <button mat-icon-button class="close-btn-absolute" (click)="onClose()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    
    <!-- Dialog Content -->
    <mat-dialog-content class="qr-dialog-content">
        <div class="qr-body">
            <span   class="shop-info">
               {{this.data.shop.code}} : {{this.data.shop.name}}
            </span>
            <!-- QR Type Selection -->
            <div class="qr-type-section">
                

                <div class="radio-group">
                    <span class="section-title">QR Code Type</span>
                    <mat-radio-group [(ngModel)]="selectedQRType" (change)="onQRTypeChange()">
                        <!-- Counter Option -->
                        <mat-radio-button value="counter" class="radio-option">
                            Counter
                        </mat-radio-button>

                        <!-- Table Option -->
                        <mat-radio-button value="table" class="radio-option">
                            Table
                        </mat-radio-button>
                    </mat-radio-group>
                </div>

                <!-- 🔧 CONDITIONAL: Table Input and Generate Button -->
                <div class="table-option">
                    <!-- Table Input - Disabled for Counter -->
                    <mat-form-field appearance="outline" class="table-input" 
                                   [class.disabled]="isTableInputDisabled()">
                        <mat-label>Table Numbers</mat-label>
                        <input matInput 
                               [(ngModel)]="tableNumber" 
                               (input)="onTableNumberChange()" 
                               type="text" 
                               placeholder="e.g., Table 1, Table 2"
                               [disabled]="isTableInputDisabled()">
                        <!-- <mat-hint *ngIf="!isTableInputDisabled()">
                            Enter table names separated by commas
                        </mat-hint> -->
                        <!-- <mat-hint *ngIf="isTableInputDisabled()">
                            Not needed for counter QR code
                        </mat-hint> -->
                    </mat-form-field>

                    <!-- Generate Button - Disabled for Counter -->
                    <button mat-raised-button 
                            [color]="selectedQRType === 'counter' ? 'primary' : 'primary'"
                            (click)="generateQRCode()"
                            [disabled]="isGenerateButtonDisabled()" 
                            class="generate-btn"
                            [class.disabled]="isGenerateButtonDisabled()">
                        <mat-icon *ngIf="isGenerating">hourglass_empty</mat-icon>
                        <mat-icon *ngIf="!isGenerating && selectedQRType === 'counter'">qr_code</mat-icon>
                        <mat-icon *ngIf="!isGenerating && selectedQRType === 'table'">qr_code</mat-icon>
                        
                        <span *ngIf="selectedQRType === 'counter'">
                            {{ isGenerating ? 'Auto-generated' : 'Auto-generated' }}
                        </span>
                        <span *ngIf="selectedQRType === 'table'">
                            {{ isGenerating ? 'Generate' : 'Generate' }}
                        </span>
                    </button>
                </div>

                <!-- 🔧 DYNAMIC: Note Section with different messages -->
                <div class="note-section">
                    <p class="note-text">
                        <strong>Note:</strong> 
                        <span *ngIf="selectedQRType === 'counter'">
                            Counter QR code is automatically generated.
                        </span>
                        <span *ngIf="selectedQRType === 'table'">
                            For Table QRs, enter table numbers separated by commas and press generate
                        </span>
                    </p>
                </div>
            </div>

            <!-- 🔧 QR DISPLAY: Rest remains the same -->
            <div class="qr-display-section">
                <!-- Loading State -->
                <div *ngIf="isGenerating" class="loading-container">
                    <mat-spinner diameter="50"></mat-spinner>
                    <p>Generating QR Code...</p>
                </div>

                <!-- Error State -->
                <div *ngIf="errorMessage && !isGenerating" class="error-container">
                    <mat-icon color="warn">error</mat-icon>
                    <p class="error-text">{{errorMessage}}</p>
                    <button mat-stroked-button (click)="generateQRCode()"
                            [disabled]="selectedQRType === 'counter'">
                        <mat-icon>refresh</mat-icon>
                        Retry
                    </button>
                </div>

                <!-- 🔧 UNIFIED: Single QR Display (Counter) -->
                <div *ngIf="selectedQRType === 'counter' && qrDataUrl && !isGenerating && !errorMessage"
                     class="qr-success-container">
                    <div class="qr-grid">
                        <div class="qr-item">
                            <div class="qr-image-container">
                                <img [src]="qrDataUrl" [alt]="'QR Code for Counter'" class="qr-image">
                            </div>
                            <div class="qr-label">Counter</div>
                        </div>
                    </div>
                </div>

                <!-- 🔧 UNIFIED: Multiple QR Display (Table) -->
                <div *ngIf="selectedQRType === 'table' && qrCodesArray.length > 0 && !isGenerating && !errorMessage"
                     class="qr-success-container">
                    <div class="qr-grid">
                        <div *ngFor="let qrCode of qrCodesArray" class="qr-item">
                            <div class="qr-image-container">
                                <img [src]="qrCode.dataUrl" [alt]="'QR Code for ' + (qrCode.tableName || 'Table')" class="qr-image">
                            </div>
                            <div class="qr-label">
                                {{ qrCode.tableName || 'Table' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 🔧 PLACEHOLDER: Empty state when no QRs generated -->
                <div *ngIf="!isGenerating && !errorMessage && !qrDataUrl && qrCodesArray.length === 0" 
                     class="empty-state">
                    <div class="empty-content">
                        <mat-icon class="empty-icon">qr_code_scanner</mat-icon>
                        <h4>No QR Codes Generated</h4>
                        <p *ngIf="selectedQRType === 'counter'">Counter QR will be auto-generated</p>
                        <p *ngIf="selectedQRType === 'table'">Click Generate to create table QR codes</p>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <!-- Dialog Actions -->
    <mat-dialog-actions align="end" class="dialog-actions">
        <button mat-button (click)="onClose()" class="cancel-btn">
            Close
        </button>

        <!-- Download QR Button -->
        <button mat-raised-button color="primary" (click)="onDownload()" 
                [disabled]="!canPrintOrDownload()" class="download-btn">
            <mat-icon>download</mat-icon>
            <span>{{ getDownloadButtonText() }}</span>
        </button>
    </mat-dialog-actions>
</div>